import React, { useState } from 'react'
import "./navbar.css"
import { Link } from 'react-router-dom'

export default function Navbar() {

    const [click, setClick] = useState(false)
    const handleClick = () => setClick(!click)

    const [color, setColor] = useState(false)
    const changeColor = () =>{
        if(window.scrollY >= 100){
            setColor(true)
        }else{
            setColor(false)
        }
    }
    window.addEventListener("scroll", changeColor)

    return (
        <>
            <div className={color ? "header header-bg" : "header"}>
                <Link to="/">
                    <h1>Hammy</h1>
                </Link>
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About</Link>
                    </li>
                    <li>
                        <Link to="/project">Projects</Link>
                    </li>
                    <li>
                        <Link to="/services">Services</Link>
                    </li>
                    <li>
                        <Link to="/contact">Contact</Link>
                    </li>
                </ul>
                <div className="hamburger" onClick={handleClick}>
                    {
                        click ? <i className="fa-solid fa-xmark" style={{ color: "white" }}></i> :
                            <i className="fa-solid fa-bars" style={{ color: "white" }}></i>
                    }

                </div>
            </div>
        </>
    )
}
